// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.justify_space_between {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    justify-items: end;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SettingsPage/PaymentGatewayPage/PaymentGateway.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;AACf","sourcesContent":[".justify_space_between {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    justify-items: end;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
